/*Match first subnav with a link that starts with the current request path*/
function detectActiveSubnav(): void {
  var match = false;
  document.querySelectorAll("#audience-navigation-desktop > ul.main-navigation-items > .main-navigation-item").forEach((subnav) => {
    subnav.querySelectorAll("a").forEach((navItem) => {
      if (!match && window.location.pathname.startsWith(navItem.attributes["href"].value)) {
        subnav.classList.add("active");
        match = true;
      }
    });
  });
  match = false;
  document.querySelectorAll("#audience-navigation-mobile > ul.main-navigation-items-dropdown > .main-navigation-item").forEach((subnav) => {
    subnav.querySelectorAll("a").forEach((navItem) => {
      if (!match && window.location.pathname.startsWith(navItem.attributes["href"].value)) {
        subnav.classList.add("active");
        match = true;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  detectActiveSubnav();
});

detectActiveSubnav();
